import useQueryParam, { QUERY_STRING_KEYS } from "hooks/useQueryParam";

const useSelectedCustomerCode = () => {
  const [selectedCustomerCode] = useQueryParam(
    QUERY_STRING_KEYS.SELECTED_CUSTOMER_KEY
  );
  return selectedCustomerCode?.split(",") ?? [];
};

export default useSelectedCustomerCode;
